import React from 'react'
import image from '../Home/images/under-construction.png'


const Teachers = () => {
    return (
        <div>
            <div className='under_construction'>
                <div className='container'>
                    <div className='text-center m-auto'>
                        <img src={image} className='img-fluid' />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Teachers
